// Copyright (c) Microsoft. All rights reserved.

import { FC, useState } from 'react';

import {
    Button,
    Divider,
    Menu,
    MenuItem,
    MenuList,
    MenuPopover,
    MenuTrigger,
    Tooltip,
} from '@fluentui/react-components';
import { useChat } from '../../../../libs/hooks';
import { useAppSelector } from '../../../../redux/app/hooks';
import { RootState } from '../../../../redux/app/store';
import { Add20 } from '../../../shared/BundledIcons';
import { InvitationJoinDialog } from '../../invitation-dialog/InvitationJoinDialog';

interface SimplifiedNewBotMenuProps {
    onFileUpload: () => void;
}

export const SimplifiedNewBotMenu: FC<SimplifiedNewBotMenuProps> = () => {
    const chat = useChat();

    // It needs to keep the menu open to keep the FileUploader reference
    // when the file uploader is clicked.
    const [isJoiningBot, setIsJoiningBot] = useState(false);

    const { listChatBotConfig } = useAppSelector((state: RootState) => state.app);

    const onAddChat = (chatBotSettingId: string) => {
        void chat.createChat(chatBotSettingId);
    };

    const onCloseDialog = () => {
        setIsJoiningBot(false);
    };

    return (
        <div>
            <Menu>
                <MenuTrigger disableButtonEnhancement>
                    <Tooltip content="Add a chat" relationship="label">
                        <Button data-testid="createNewConversationButton" icon={<Add20 />} appearance="transparent" />
                    </Tooltip>
                </MenuTrigger>
                <MenuPopover>
                    <MenuList>
                        {listChatBotConfig?.map((chatBotConfig, index) => {
                            return (
                                <div key={chatBotConfig.id}>
                                    <MenuItem
                                        key={chatBotConfig.id}
                                        content={chatBotConfig.chatBotSettingName}
                                        onClick={() => {
                                            onAddChat(chatBotConfig.id);
                                        }}
                                    />
                                    {index !== listChatBotConfig.length - 1 && <Divider key={`divider-${index}`} />}
                                </div>
                            );
                        })}
                    </MenuList>
                </MenuPopover>
            </Menu>
            {isJoiningBot && <InvitationJoinDialog onCloseDialog={onCloseDialog} />}
        </div>
    );
};
